import "esbuild-css-modules-plugin-ns-css:src/js/home.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/home.module.css:injector.js";
export default new Proxy({
  "topicsContainer": "home-module__topicsContainer_g41GTq__1100",
  "viewingRequirementsHeader": "home-module__viewingRequirementsHeader_g41GTq__1100",
  "viewingRequirementsParagraph": "home-module__viewingRequirementsParagraph_g41GTq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      